<template>
  <wrap class="d_wrap" ref="wrap" :title="title">
    <p class="user">
      <span class="label">账号：</span>
      <span class="text" v-if="d23.userinfo.nickname==''">{{d23.userinfo.username}}</span>
      <span class="text" v-else>{{d23.userinfo.username}} ({{d23.userinfo.nickname}})</span>
    </p>
    <p>
      <span class="label">总额：</span>
      <span class="text" v-if="d23.userinfo.status==3">冻结</span>
      <span class="text" v-else>{{d23.userinfo.credit_limit}}</span>

      <!--<span class="label">可用余额：</span>
      <span class="text">{{d23.userinfo.credit_balance}}</span>-->

      <span class="label">用户类型：</span>
      <span class="text" v-if="d23.userinfo.account_type==1">信用盘</span>
      <span class="text" v-else-if="d23.userinfo.account_type==2">现金盘</span>

      <span class="label">盘口：</span>
      <span class="text">{{d23.userinfo.market|formatMarket}}</span>

      <span class="label">最低下注额：</span>
      <span class="text">{{d23.minbet}}</span>
    </p>

    <CTable class="content" :head="head" :body="body">
      <!--
        自定义模版
        slot=head字段名
        slot-scope=数据索引
      -->
      <template slot-scope="scope" slot="user">
        <span class="wrap">{{scope.data.user}}</span>
      </template>
    </CTable>
  </wrap>
</template>

<script>
// 个人中心
import CTable from "./table";
import Wrap from "./wrap";
import mixin from "./mixin";
import CSelect from "../c_select";
import { mapState, mapActions } from "vuex";

export default {
  name: "QC23",
  mixins: [mixin],
  components: { Wrap, CTable, CSelect },
  data() {
    return {
      type: 0,
      lottery_type: "",
      rebate: []
    };
  },
  computed: {
    ...mapState({
      d23: state => state.table.d23
    }),
    head() {
      var response = [
        { label: "彩种名称", value: "lottery_name" },
        { label: "交易类型", value: "played_name" },
        { label: "单注最高", value: "single_limit" },
        { label: "单期限额", value: "total_limit" }
      ];
      var split = this.d23.userinfo.market;
      for(var i=0;i<split.length;i++){
          var lower = split[i].toLowerCase();
          response.push({
            label: `${split[i]}盘退水`,
            value:`rebate_${lower}`
          });
      }
      return response;
    },
    body() {
      return this.rebate;
    }
  },
  filters: {
      formatMarket: function (value) {
        return value.join(",");
      }
  },
  async mounted() {
    await this.getData();
    this.rebate = this.d23.profile;
  },
  methods: {
    ...mapActions("table", {
      getData: "load_d23_data"
    })
  }
};
</script>

<style lang="stylus" scoped>
.d_wrap {
  font-size: 14px;

  .user {
    margin-bottom: 10px;
  }

  span {
    display: inline-block;
  }

  .text {
    margin-right: 20px;
  }
}

.content {
  margin-top: 15px;
}

.wrap {
  display: inline-block;
  text-align: center;
  width: 100px;
}

.date {
  height: 34px;
  font-size: 14px;
  color: #000000;
  padding-bottom: 10px;

  .item {
    float: left;
  }

  .select {
    width: auto;
    min-width: 140px;
    height: 32px;
    border-radius: 2px;
    margin-right: 10px;
    background-color: transparent;
    border: 1px solid #e0e0e0;
  }

  .m10 {
    margin: 0 10px;
  }

  .search {
    display: inline-block;
    height: 100%;
    color: #ffffff;
    vertical-align: top;
    line-height: 34px;
    width: 60px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC23.vue